import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Action",
  "use": "Action-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Action\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 6a2 2 0 0 1-3.855.75H9a1.25 1.25 0 1 0 0 2.5h4.895a2 2 0 0 1 3.72.024 2.75 2.75 0 0 1-.365 5.476h-7.145a2 2 0 0 1-3.69.046 1.25 1.25 0 0 0 .335 2.454h4.645a2 2 0 1 1 0 1.5H6.75a2.75 2.75 0 0 1-.364-5.476 2 2 0 0 1 3.719-.024h7.145a1.25 1.25 0 0 0 .335-2.454 2 2 0 0 1-3.69-.046H9a2.75 2.75 0 0 1 0-5.5h1.145A2 2 0 0 1 14 6Z\" fill=\"#495973\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol